import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostCommentsLoading, EGetPostCommentsActionType } from './types';

export const getPostCommentsLoading: () => TGetPostCommentsLoading =
  actionGenerator<EGetPostCommentsActionType.Loading>(EGetPostCommentsActionType.Loading);
